module.exports = __webpack_public_path__ + "static/media/windows-sound-remix.516ca6c6.gif";